import devTools from "devtools-detect";
import { useEffect } from "react";

const InspectValidator = ({ children }) => {

    useEffect(() => {
        window.addEventListener("resize", checkDevTools);
        return () => {
            window.removeEventListener("resize", checkDevTools);
        };
    }, []);

    const checkDevTools = () => {
        console.log("DevTools is open:", devTools.isOpen);
    };

    return children
}

export default InspectValidator;